<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button variant="primary" :to="{ name: 'propagate-create', params: dataType }">
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <!-- Filters -->
    <b-card no-body>
      <b-card-body class="p-1">
        <b-row>
          <div class="col-12 col-md-3">
            <b-form-group label="Ngày đăng" class="mb-0">
              <date-picker v-model="loadDateRange" type="datetime" range ref="datetime" :shortcuts="shortcuts"
                :show-time-panel="false" format='DD/MM/YYYY' valueType="format" input-class="form-control"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"></date-picker>
            </b-form-group>
          </div>
          <b-col cols="12" md="2" class="mt-1 mt-md-0">

            <b-form-group label="Trạng thái">
              <v-select v-model="status" :options="statusOptions" class="w-100" label="name" :reduce="val => val.id"
                placeholder="--Chọn--" @input="(val) => $emit('update:status', val)" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2" class="mt-1 mt-md-0">

            <b-form-group label="Chuyên mục">
              <v-select v-model="category_id" :options="propagateType" class="w-100" label="name" :reduce="val => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="mt-1 mt-md-0">
            <b-form-group label="Từ khóa">
              <b-input-group>
                <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Tiêu đề" />
                <b-input-group-append>
                  <b-button variant="primary" @click="updateSearchQuery">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- List -->
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <b-table ref="refListTable" class="table-responsive" :items="dataItems" responsive :fields="tableColumns"
          primary-key="id" show-empty empty-text="No matching records found">
          <!-- Column: Status -->
          <template #cell(title)="data">
            <span class="links" @click="onPreview(data.item.id)"><strong>{{ data.item.title }}</strong></span>
          </template>
          <template #cell(category_id)="data">
            {{ showCategory(data.item.category_id) }}
          </template>
          <template #cell(created_at)="data">
            {{ moment.unix(data.item.created_at).format('DD/MM/YYYY HH:mm') }}
          </template>
          <template #cell(status)="data">
            <span v-if="data.item.status == 5" class="badge badge-light-success">Xuất bản</span>
            <span v-else-if="data.item.status == 1" class="badge badge-light-warning">Mới tạo</span>
            <span v-else class="badge badge-light-danger">Hủy xuất bản</span>
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" class="" variant="outline-primary"
              :to="{ name: 'propagate-edit', params: { id: data.item.id } }">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button size="sm" class="ms-2" variant="outline-danger" @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', {
                from: dataMeta.from, to: dataMeta.to, of: dataMeta.of,
              }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal id="propagateView" no-close-on-backdrop hide-footer size="lg" title="Xem trước" @close="hidenView">
      <propagate-preview :propagate_id="propagate_id" @updateList="handleDialog" />
    </b-modal>
  </div>
</template>
<script>
import {
  BCard, BOverlay, BCardBody, BCardHeader, BRow, BCol, BFormInput, BButton, BTable,
  BBadge, BDropdown, BPagination, BInputGroupAppend, BInputGroup, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch, computed } from '@vue/composition-api'
import moment from 'moment';
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import PropagatePreview from './PropagatePreview.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    vSelect,
    PropagatePreview,
    BFormGroup,
    DatePicker
  },
  data() {
    return {
      moment, // This is the one line of code that you need
      propagate_id: '',
    }
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup() {
    const { router } = useRouter();
    const refListTable = ref(null)
    const loadDateRange = ref('')
    // Table Handlers
    const tableColumns = [
      { key: 'id', sortable: false, class: 'itemid' },
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      { key: 'created_at', sortable: false, label: 'Thời gian tạo', thAttr: { width: '15%' } },
      { key: 'category_id', sortable: false, label: 'Loại', thAttr: { width: '15%' } },
      { key: 'status', sortable: false, label: 'Trạng thái', thAttr: { width: '10%' } },
      { key: 'actions', label: 'Hành động', class: 'action', thAttr: { width: '8%' } },
    ];
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const category_id = ref('')
    const status = ref('')
    const dataItems = ref([]);
    const dataType = ref([]);
    const localSearchQuery = ref('')
    const loading = ref(false)
    const start_date = ref('');
    const end_date = ref('');
    const propagateType = ref([])

    const fetchAll = () => {
      loading.value = true
      store.dispatch('propagate/fetchAll', {
        keyword: localSearchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        status: status.value,
        start_date: start_date.value,
        end_date: end_date.value,
        category_id: category_id.value,
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            dataItems.value = result.data.data;
            total.value = result.data.data.total;
            propagateType.value = result.data.propagateType
          }
        })
    }
    fetchAll()
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage], () => {
      if (!loading.value) {
        refetchData()
      }
    })

    watch([perPage, searchQuery, status, category_id, start_date, end_date], () => {
      currentPage.value = 1
      if (!loading.value) {
        refetchData()
      }
    })

    const refetchData = () => {
      fetchAll()
    }

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value;
      refetchData()
    };
    const statusOptions = ref([
      { id: 1, name: 'Mới tạo' },
      { id: 5, name: 'Đã xuất bản' },
      { id: 7, name: 'Hủy xuất bản' },
    ])

    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [moment().add(-1, 'days').toDate(), moment().add('-1', 'days').toDate()] },
      { text: 'Tuần trước', onClick: () => [moment().subtract(1, 'weeks').startOf('weeks').toDate(), moment().subtract(1, 'weeks').endOf('weeks').toDate()] },
      { text: 'Tuần hiện tại', onClick: () => [moment().startOf('weeks').toDate(), moment().endOf('weeks').toDate()] },
      { text: 'Tháng hiện tại', onClick: () => [moment().startOf('month').toDate(), moment().endOf('month').toDate()] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] }
    ])
    return {
      loading,
      dataItems,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      dataType,
      status,
      localSearchQuery,
      start_date,
      end_date,
      statusOptions,
      propagateType,
      category_id,
      updateSearchQuery,
      loadDateRange,
      shortcuts
    }
  },
  methods: {
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa chỉ đạo này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const { id } = item
          store.dispatch('propagate/destroy', id)
            .then(response => {
              const result = response.data
              if (result.code === 200) {
                showToast(result.message, { variant: 'success' })
                this.refetchData()
              } else {
                showToast(result.message)
              }
            })
        }
      })
    },
    handleDialog() {
      this.$bvModal.hide('propagateView');
      this.refetchData();
    },
    hidenView() {
      this.$bvModal.hide('propagateView');
    },
    onPreview(id) {
      this.propagate_id = id;
      this.$bvModal.show('propagateView');
    },
    showCategory(category_id) {
      let category_name = '';
      this.propagateType.forEach((item) => {
        if (item.id == category_id) {
          category_name = item.name;
        }
      });
      return category_name
    },
    doSearch() {
      this.searchQuery = this.localSearchQuery;

      if (this.start_time && this.start_time > this.end_time) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false;
      }
      this.start_date = this.start_time;
      this.end_date = this.end_time

      this.refetchData()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
